import React from "react";
import { Footer, Navbar } from "../components";
import ContactForm from "../components/contact/ContactForm";
import Seo from "../components/Seo";

function Contact() {
  return (
    <div>
      <Seo
        title="Contact Us"
        description="Get in touch with WayaQuick. Reach our team by email, phone or at our Lagos office, or send us a message."
      />
      <Navbar />
      <ContactForm />
      <Footer />
    </div>
  );
}

export default Contact;
